import { render, staticRenderFns } from "./MyTenantProjects.vue?vue&type=template&id=56bffde2&scoped=true&"
import script from "./MyTenantProjects.vue?vue&type=script&lang=js&"
export * from "./MyTenantProjects.vue?vue&type=script&lang=js&"
import style0 from "./MyTenantProjects.vue?vue&type=style&index=0&id=56bffde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bffde2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bffde2')) {
      api.createRecord('56bffde2', component.options)
    } else {
      api.reload('56bffde2', component.options)
    }
    module.hot.accept("./MyTenantProjects.vue?vue&type=template&id=56bffde2&scoped=true&", function () {
      api.rerender('56bffde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/dashboards/MyTenantProjects.vue"
export default component.exports